export default "__VITE_ASSET__BsxQ2tFN__"